var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"show-status"},[_vm._v("\n  ⬤\n  "),(_vm.hasDefaultSlot)?_c('q-tooltip',[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }